import { observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import Modal from 'react-modal';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CardStore } from '@intelingu/core/stores/CardStore';

interface ProgressBarModalProps {
}

@observer export class ProgressBarModal extends Component<ProgressBarModalProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;

    @observable isOpen = true;
    audioSuccessRef;
    reaction;

    componentDidMount(): void {
        this.reaction = reaction(() => this.cardStore.progress.achievement, () => {
            if (this.cardStore.progress.achievement != null) {
                this.audioSuccessRef.currentTime = 0;
                this.audioSuccessRef.play();
            }
        })
    }

    componentWillUnmount(): void {
        this.reaction();
    }

    render() {
        return <>
            <div className={'hidden'}>
                <audio ref={elm => this.audioSuccessRef = elm}
                       className={'invisible-audio'}
                       autoPlay={false}
                       controls>
                    <source src={require(`assets/sounds/success-fanfare-trumpets.mp3`)} />
                </audio>
            </div>

            <Modal isOpen={this.cardStore.progress.achievement !== null}
                   overlayClassName={'modal-overlay'}
                   ariaHideApp={false}
                   shouldCloseOnOverlayClick={true}
                   onRequestClose={() => {
                       console.log('request close');
                       this.cardStore.progress.achievement = null;
                   }}
                   className={'progress-bar-achievement'}>

                { this.cardStore.progress.achievement && <div className={'achievement'}>
                    <div className={'bg'} style={{ background: `url('${this.cardStore.progress.achievement.image || require('assets/images/pb-congrat.jpg')}')` }}>
                        <h2>Respekt!</h2>
                        <p>Du hast dein Pensum gesteigert...</p>
                        <div className={'content'}>
                            { this.cardStore.progress.achievement.description }
                        </div>

                        <a href={''} className={'close'} onClick={e => {
                            e.preventDefault();
                            this.cardStore.progress.achievement = null;
                        }}>
                            <i className="icon ion-md-close" />
                        </a>
                    </div>
                </div> }
            </Modal>
        </>
    }

}
